module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-credit-records"
  }, [_c('ActionBar', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.type) + " Credit")]), (_vm.expanded) ? _c('i', {
    staticClass: "fa fa-plus-circle fa-2x",
    attrs: {
      "slot": "action"
    },
    on: {
      "click": function($event) {
        _vm.addCredit = !_vm.addCredit
      }
    },
    slot: "action"
  }) : _vm._e(), _c('i', {
    staticClass: "fa fa-2x",
    class: {
      'fa-eye-slash': _vm.expanded, 'fa-eye': !_vm.expanded
    },
    attrs: {
      "slot": "action"
    },
    on: {
      "click": function($event) {
        _vm.expanded = !_vm.expanded
      }
    },
    slot: "action"
  })]), (_vm.addCredit) ? _c('div', {
    staticClass: "add-credit"
  }, [_c('label', [_vm._v("Amount"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.amount),
      expression: "body.amount"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.body.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "amount", $event.target.value)
      }
    }
  })]), _c('ActionButton', {
    attrs: {
      "action": _vm.addNewCredit
    }
  }, [_vm._v("Add Credit")])], 1) : _vm._e(), (_vm.expanded) ? _c('base-list', {
    ref: "listCr",
    attrs: {
      "component": _vm.component,
      "search": _vm.search,
      "dataLoader": _vm.dataLoader,
      "resultsPerPage": 5
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b01edc5e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/PaidCreditRecords.vue
// module id = 2665
// module chunks = 1